import { Link } from "react-router-dom";
import { ArrowUpRight, FileText, MapPin, BookOpen } from "lucide-react";
import { useLp } from "../i18n/lang";
import { useCopy } from "../i18n/copy";

export const ServiceCard = ({ service, index }) => {
  const lp = useLp();
  return (
    <Link
      to={lp(`/servicios/${service.slug}/`)}
      data-testid={`service-card-${service.slug}`}
      className="card-technical group p-6 sm:p-7 flex flex-col"
    >
      <div className="flex items-start justify-between">
        <span className="font-mono text-xs text-cadastral tracking-widest">
          {String(index + 1).padStart(2, "0")}
        </span>
        <ArrowUpRight size={18} className="text-slate-300 transition-all group-hover:text-terracotta group-hover:translate-x-0.5 group-hover:-translate-y-0.5" aria-hidden="true" />
      </div>
      <h3 className="mt-4 text-lg font-semibold text-ink leading-snug group-hover:text-terracotta transition-colors">
        {service.shortName}
      </h3>
      <p className="mt-2 text-sm text-slate-600 leading-relaxed flex-1">{service.excerpt}</p>
    </Link>
  );
};

export const ProblemCard = ({ problem }) => {
  const lp = useLp();
  return (
    <Link
      to={lp(`/problemas/${problem.slug}/`)}
      data-testid={`problem-card-${problem.slug}`}
      className="card-technical group p-6 flex items-start gap-4"
    >
      <MapPin size={20} className="mt-0.5 shrink-0 text-terracotta" aria-hidden="true" />
      <div className="flex-1">
        <h3 className="text-base font-semibold text-ink leading-snug group-hover:text-terracotta transition-colors">
          {problem.shortName}
        </h3>
        <p className="mt-1.5 text-sm text-slate-600 leading-relaxed">{problem.excerpt}</p>
      </div>
      <ArrowUpRight size={16} className="mt-1 shrink-0 text-slate-300 group-hover:text-terracotta transition-colors" aria-hidden="true" />
    </Link>
  );
};

export const GuideCard = ({ guide }) => {
  const lp = useLp();
  const cm = useCopy("common");
  return (
    <Link
      to={lp(`/guias/${guide.slug}/`)}
      data-testid={`guide-card-${guide.slug}`}
      className="card-technical group p-6 flex flex-col"
    >
      <span className="tech-label !text-[10px]">{guide.category}</span>
      <h3 className="mt-3 text-lg font-semibold text-ink leading-snug group-hover:text-terracotta transition-colors">
        {guide.title}
      </h3>
      <p className="mt-2 text-sm text-slate-600 leading-relaxed flex-1">{guide.excerpt}</p>
      <span className="mt-4 flex items-center gap-1.5 text-xs font-medium text-cadastral">
        <BookOpen size={13} aria-hidden="true" /> {cm.readGuide}
      </span>
    </Link>
  );
};

export const UpcomingCard = ({ title, category, href }) => {
  const lp = useLp();
  const cm = useCopy("common");
  const inner = (
    <>
      <span className="tech-label !text-[10px] !text-slate-400">{category}</span>
      <h3 className="mt-3 text-base font-semibold text-slate-500 leading-snug">{title}</h3>
      <span className="mt-4 flex items-center gap-1.5 text-xs font-mono text-slate-400 tracking-wider uppercase">
        <FileText size={13} aria-hidden="true" /> {href ? cm.seePage : cm.inPrep}
      </span>
    </>
  );
  return href ? (
    <Link to={lp(href)} className="border border-dashed border-slate-300 rounded-sm p-6 flex flex-col hover:border-cadastral/50 transition-colors" data-testid="guide-upcoming-card">
      {inner}
    </Link>
  ) : (
    <div className="border border-dashed border-slate-300 rounded-sm p-6 flex flex-col opacity-75" data-testid="guide-upcoming-card">
      {inner}
    </div>
  );
};
